import { Action } from '@ngrx/store';
import {
  ReferenceDocuments,
  CommercialProductRecommendation,
  RmsContractBalance,
  PaymentTerm,
} from '@cemex-core/cmx-api';

export enum ContractActionTypes {
  LOAD_AVAILABLE_CONTRACTS = '[Rms Contract] Available contracts',
  LOAD_CONTRACT_BALANCE = '[Rms Contract] Load balance',
  BALANCE_COMPLETED = '[Rms Contract] Balance completed',
  LOAD_CONTRACT_PAYMENT_TERM = '[Rms Contract] Load contract payment term',
  RESET_CONTRACT_BALANCE = '[Rms Contract] Reset contract balance',
  RESET = '[Rms Contract] Reset',
}

export class LoadAvailableContracts implements Action {
  readonly type = ContractActionTypes.LOAD_AVAILABLE_CONTRACTS;

  constructor(
    public payload: {
      productCode: string;
      salesDocuments: ReferenceDocuments[];
    },
  ) {}
}

export class LoadBalanceContracts implements Action {
  readonly type = ContractActionTypes.LOAD_CONTRACT_BALANCE;

  constructor(public payload: CommercialProductRecommendation) {}
}

export class ContractBalanceCompleteAction implements Action {
  readonly type = ContractActionTypes.BALANCE_COMPLETED;
  constructor(
    public payload: {
      [agreementId: number]: RmsContractBalance[];
    },
  ) {}
}
export class LoadContractPaymentTermAction implements Action {
  readonly type = ContractActionTypes.LOAD_CONTRACT_PAYMENT_TERM;
  constructor(public payload: PaymentTerm[]) {}
}

export class ContractsResetBalanceAction implements Action {
  readonly type = ContractActionTypes.RESET_CONTRACT_BALANCE;

  constructor() {}
}

export class ContractsResetAction implements Action {
  readonly type = ContractActionTypes.RESET;

  constructor() {}
}

export type ContractActions =
  | LoadAvailableContracts
  | LoadBalanceContracts
  | ContractBalanceCompleteAction
  | LoadContractPaymentTermAction
  | ContractsResetBalanceAction
  | ContractsResetAction;
